import { Component } from '@angular/core';
import { LoadingService } from './loading.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-loading',
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css'
})
export class LoadingComponent {
  constructor(public loading: LoadingService) {}
}
